import React, { useContext } from "react";
import { observer } from "mobx-react";
import { isGamesTheme } from "@utils";
import { Clock, Language } from "@components-shared/desktop";
import {
	HeaderLogo,
	HeaderSearch,
	HeaderUserDetails,
	HeaderThemeToggle,
	HeaderSpecialLinks,
	HeaderNavigation,
} from "./components";
import ScrollDirectionContext from "@state/context/scroll/ScrollDirectionContext";
import CasinoHeaderSearch from "./components/CasinoHeaderSearch";

export default observer(function HeaderWithSideMenu(props: {
	onNavTargetClick?: Parameters<typeof HeaderNavigation>[0]["onTargetClick"];
}) {
	const scrollDirection = useContext(ScrollDirectionContext);

	return (
		<header className={"l--header is-" + scrollDirection}>
			<div className={"header is-" + scrollDirection}>
				<div className="header__top">
					<Clock />

					<div className="header__settings">
						{!isGamesTheme() && <HeaderSearch />}
						<CasinoHeaderSearch />

						<Language rounded />
						<HeaderThemeToggle />
					</div>
				</div>

				<div className="header__main">
					<div className="header__col header__col--left">
						<HeaderLogo />
						<HeaderSpecialLinks />
					</div>

					<div className="header__col header__col--grow">
						<HeaderNavigation
							onTargetClick={props.onNavTargetClick}
						/>
					</div>

					<div className="header__col header__col--right">
						<HeaderUserDetails />
					</div>
				</div>
			</div>
		</header>
	);
});
